import $ from 'jquery';

$('#lightgallery  .slide').hide()

require('lightgallery/dist/js/lightgallery-all.min')

function runGallery() {
    const slides = []
    const imgindex = $(this).data('imgindex');
    $('#lightgallery .item').each(function () {
        slides.push({'src': $(this).data('src')})
    })
    const $lg = $(this).lightGallery({
        autoplay: false,
        dynamic: true,
        share: false,
        download: false,
        thumbnail: false,
        index: imgindex,
        dynamicEl: slides
    })

}

$('#gallery .slide').on('click', runGallery);
